module.exports = __webpack_public_path__ + "static/img/3areaA_13.1c5688e.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダー系/3areaA_13.png
// module id = 960
// module chunks = 1